export enum ColorVariantType {
    Primary = 'primary',
    OnPrimary = 'on-primary',
    Error = 'error',
    Neutral = 'neutral',
    Dark = 'dark',
    Dim = 'dim',
    Darkest = 'darkest',
}
